import{a as e}from"./chunk-CN4WMJ52.js";import{a as c}from"./chunk-QN5222E2.js";import{e as t}from"./chunk-HOIFE66X.js";import{m as o}from"./chunk-HBP5N4FR.js";o();c();function f(r){e.dispatch(t(r))}export{f as a};
//# sourceMappingURL=chunk-DJWISBYW.js.map
